var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperiences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.03 38.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.57 7.58a3 3 0 0 1-3.13-2.94 3 3 0 0 1 3-3.14 3 3 0 0 1 .18 6.08zM6.86 9.77s-2.45.17-3.43 1.06c-2.43 2.17-1.87 11-1.87 11s0 1.7 1.46 1.69a1.71 1.71 0 0 0 1.7-1.75l.28-6.5-.71 20.53a1.66 1.66 0 0 0 3.31-.26s0-9.56.23-10.22A1.14 1.14 0 0 1 9 24.51h.12a1.13 1.13 0 0 1 1.21.81c.23.66.23 10.22.23 10.22a1.66 1.66 0 0 0 3.31.26l-.6-20.47 7.27-6s2-1.46.73-3c-.91-1.12-2.78.06-2.78.06S12.76 10 11.35 9.77a30 30 0 0 0-4.49 0m28.61-2.19a3 3 0 1 0 .18-6.08 3.07 3.07 0 0 0-3 3.06 3.06 3.06 0 0 0 2.82 3.02m1.71 2.19s2.44.17 3.42 1.06c2.45 2.21 1.87 11 1.87 11s0 1.7-1.46 1.69a1.71 1.71 0 0 1-1.7-1.75l-.22-6.5.66 20.53a1.67 1.67 0 0 1-3.32-.26s0-9.56-.23-10.22a1.13 1.13 0 0 0-1.2-.81h-.12a1.14 1.14 0 0 0-1.21.81c-.23.66-.23 10.22-.23 10.22a1.66 1.66 0 0 1-3.31.26l.61-20.47-7.28-6s-2-1.46-.73-3c.91-1.12 2.78.06 2.78.06s5.76 3.61 7.18 3.38a30 30 0 0 1 4.49 0",
    "data-name": "Layer 37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiences);
export default __webpack_public_path__ + "static/media/experiences.707f0ec4988831c5ff4df059fc2aa97a.svg";
export { ForwardRef as ReactComponent };